import React from 'react';
import { Modal, Button, Space } from 'antd';

const UnsavedChangesModal = ({ 
  visible, 
  saving,
  onSave, 
  onContinueWithoutSaving, 
  onCancel 
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      closable={true}
      width={500}
      bodyStyle={{
        background: 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
        padding: '40px 30px',
        borderRadius: '12px',
        textAlign: 'center'
      }}
      style={{ 
        top: 20 
      }}
    >
      <div style={{ 
        color: 'white',
        fontSize: '28px',
        fontWeight: '300',
        marginBottom: '20px',
        lineHeight: '1.4'
      }}>
        El artículo no ha sido guardado.
        <br />
        ¿Quieres guardarlo?
      </div>

      <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '30px' }}>
        <Button
          size="large"
          onClick={onContinueWithoutSaving}
          style={{
            width: '100%',
            height: '50px',
            borderRadius: '25px',
            fontSize: '16px',
            fontWeight: '500',
            background: 'transparent',
            borderColor: 'white',
            color: 'white',
            borderWidth: '2px'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
          }}
        >
          Continuar sin guardar
        </Button>

        <Button
          type="primary"
          size="large"
          loading={saving}
          onClick={onSave}
          style={{
            width: '100%',
            height: '50px',
            borderRadius: '25px',
            fontSize: '16px',
            fontWeight: '500',
            background: 'white',
            borderColor: 'white',
            color: '#4a90e2'
          }}
          onMouseEnter={(e) => {
            if (!saving) e.target.style.background = '#f0f0f0';
          }}
          onMouseLeave={(e) => {
            if (!saving) e.target.style.background = 'white';
          }}
        >
          Guardar
        </Button>

        <Button
          type="link"
          size="large"
          onClick={onCancel}
          style={{
            width: '100%',
            height: '40px',
            fontSize: '16px',
            color: 'white',
            textDecoration: 'underline'
          }}
        >
          Cancelar
        </Button>
      </Space>
    </Modal>
  );
};

export default UnsavedChangesModal;

